import { z } from 'zod';
/** Surrogate identifiers are PostgreSQL bigint values, carried as strings (SDD §10.3). */
export const IdSchema = z.string().regex(/^[1-9]\d{0,18}$/, 'must be a positive integer string');
/** Business dates are calendar dates without time zone, YYYY-MM-DD (SDD §10.3). */
export const BusinessDateSchema = z.iso.date();
/** Timestamps are ISO-8601 in UTC (SDD §10.3). */
export const TimestampSchema = z.iso.datetime();
/**
 * List query conventions (SDD §10.4): `?page=1&pageSize=50`, maximum 200, plus whitelisted
 * `filter[...]` and `sort`. Which fields a resource accepts is declared by that resource, not
 * here — this schema only fixes the shape and the bounds.
 */
export const ListQuerySchema = z.strictObject({
    page: z.coerce.number().int().min(1).max(100_000).optional(),
    pageSize: z.coerce.number().int().min(1).max(200).optional(),
    /** Comma-separated, `-` for descending, e.g. `-email,id`. */
    sort: z.string().max(200).optional(),
    filter: z.record(z.string().max(50), z.string().max(200)).optional(),
});
/** Returned alongside a page of results (SDD §10.4). */
export const PageMetaSchema = z.object({
    page: z.number().int(),
    pageSize: z.number().int(),
    total: z.number().int(),
});
//# sourceMappingURL=encoding.js.map